import { Card, CardContent, Grid } from "@material-ui/core";
import React from "react";
import { withRouter } from "react-router-dom";
import AddIcon from "../../../assets/icons/PLUS.svg";
import { DUMMY_FUNCTION } from "../../../constants";
import { currentCount } from "../../../services/apiRequestMethods";
import { calculatePageNumberFromOffset } from "../../../services/commonMethods";
import { BootstrapTooltip } from "../ActionColumn";
import CustomButton from "../Button";
import FooterPagination from "../FooterPagination";
import FilterData from "../FilterData";
import NewFooterPagination from "../NewFooterPagination";

const TopCardBar = ({
  noTitle,
  title,
  btnLeftSide,
  listBool,
  btnText,
  btnMethod,
  history,
  brandLgCount,
  secondButton,
  thirdButton,
  buttonTooltip,
  btnDisabled,

  btnIcon,
  btnClass = "",
  btnIconDisabled = false,
}) => {
  const tooltipProps = { title: buttonTooltip, placement: "top" };
  if (!buttonTooltip) {
    tooltipProps.open = false;
  }
  return (
    <Grid container justifyContent="space-between">
      {noTitle ? (
        ""
      ) : (
        <Grid
          lg={brandLgCount ? brandLgCount : 9}
          md={brandLgCount ? brandLgCount : 5}
          sm={brandLgCount ? brandLgCount : 9}
          item
        >
          <h5 className="card-brand"> {title}</h5>
        </Grid>
      )}
      <Grid
        lg={brandLgCount ? 12 - brandLgCount : 3}
        md={brandLgCount ? 12 - brandLgCount : 7}
        sm={brandLgCount ? 12 - brandLgCount : 3}
        className={btnLeftSide ? "text-left" : "text-right"}
        item
      >
        {listBool ? (
          <BootstrapTooltip {...tooltipProps} title={tooltipProps.title || ""}>
            <span>
              <CustomButton
                type="button"
                btnProps={{
                  text: [
                    btnIconDisabled ? (
                      ""
                    ) : (
                      <img
                        src={btnIcon || AddIcon}
                        className="add-icon"
                        alt="Add-btn Icon Image"
                        key={0}
                      />
                    ),
                    btnText,
                  ],
                  variant: "contained",
                  className: `add-btn`,
                  onClick: !btnDisabled ? btnMethod : DUMMY_FUNCTION,
                }}
              />
            </span>
          </BootstrapTooltip>
        ) : (
          ""
        )}
        <span> {secondButton}</span>
      </Grid>

      <Grid>{thirdButton}</Grid>
    </Grid>
  );
};

function CardContainer(props) {
  let {
    resetRef,
    paginationParams,
    paginationItemsTitle,
    paginationEnabled,
    newpaginationEnabled,
    requestPaginationData,
    isFilterAvailable,
    filterdata,
    filterHandler,
    hideDateFilter,
    dynamicArray,
    preSelectedFilters,
    dynamicFilterMethod,
  } = props;

  let style = {};
  if (props.addScroll) {
    style = {
      height: `${props.customHeight ? props.customHeight : "90vh"}`,
      overflowY: "auto",
      overflowX: "hidden",
    };
  }

  //If limit=-1, then change it to 10.
  if (paginationEnabled && !~paginationParams.limit) {
    paginationParams.limit = 10;
  }

  //returns payload for api.
  function getPaginationPayload(nextParams) {
    return { ...paginationParams, ...nextParams };
  }

  //On change handler for pagination
  const changeInPagination = (type, pageNumber, ev) => {
    if (type === "limit") {
      //Reset page in case of limit change.
      return requestPaginationData(
        getPaginationPayload({
          limit: ev.target.value,
          currentPage: 1,
          offset: 0,
        })
      );
    } else {
      return requestPaginationData(
        getPaginationPayload({
          currentPage: pageNumber,
          offset: (parseInt(pageNumber) - 1) * parseInt(paginationParams.limit),
        })
      );
    }
  };

  const getPaginationTitle = function () {
    return `${currentCount(
      paginationParams.offset,
      paginationParams.total,
      paginationParams.limit
    )} ${paginationItemsTitle}`;
  };

  return (
    <React.Fragment>
      <Card
        raised={true}
        classes={{
          root: `${
            props.isBorderAvailable ? "card-container-new" : "card-container"
          }`,
          // root: "card-container-new",
        }}
      >
        <CardContent style={style}>
          <TopCardBar {...props} />
          {isFilterAvailable && (
            <FilterData
              resetRef={resetRef}
              dynamicArray={dynamicArray}
              dynamicFilterMethod={dynamicFilterMethod}
              preSelectedFilters={preSelectedFilters}
              FilterCategories={filterdata}
              filterHandler={filterHandler}
              hideDateFilter={hideDateFilter ? true : false}
            />
          )}

          {props.children}
        </CardContent>
      </Card>
      <div>
        {paginationEnabled && (
          <FooterPagination
            itemProps={{
              value: paginationParams.limit,
              name: "limit",
              onChange: (ev) => changeInPagination("limit", null, ev),
            }}
            title={getPaginationTitle()}
            paginationProps={{
              activePage: calculatePageNumberFromOffset(paginationParams),
              itemsCountPerPage: parseInt(paginationParams.limit),
              totalItemsCount: parseInt(paginationParams.total),
              onChange: (pageNumber) =>
                changeInPagination("page", pageNumber, null),
            }}
            totalLength={paginationParams.total}
          />
        )}
        {newpaginationEnabled && (
          <NewFooterPagination
            itemProps={{
              value: paginationParams.limit,
              name: "limit",
              onChange: (ev) => changeInPagination("limit", null, ev),
            }}
            title={getPaginationTitle()}
            paginationProps={{
              activePage: calculatePageNumberFromOffset(paginationParams),
              itemsCountPerPage: parseInt(paginationParams.limit),
              totalItemsCount: parseInt(paginationParams.total),
              onChange: (pageNumber) =>
                changeInPagination("page", pageNumber, null),
            }}
            totalLength={paginationParams.total}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default withRouter(CardContainer);
